import FleetGrouped from "@/models/FleetGrouped";
import VehicleTransformer from "@/transformers/VehicleTransformer";
import CollectionTransformer from "@/transformers/CollectionTransformer";

export default class FleetGroupedTransformer {

    constructor(collectionTransformer = new CollectionTransformer, vehicleTransformer = new VehicleTransformer) {
        this.collectionTransformer = collectionTransformer
        this.vehicleTransformer = vehicleTransformer
    }

    transform (data) {
        return new FleetGrouped(
            data.fleetId,
            data.fleetName,
            this.collectionTransformer.transform(this.vehicleTransformer, data.vehicles)
        );
    }
}
